import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServiceDeskNavigationResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { knowledgeHubArticleEmbedEditorRoute } from '@atlassian/jira-router-routes-servicedesk-knowledge-hub-routes/src/knowledgeHubArticleEmbedEditorRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { getKnowledgeHubResources } from './common/getKnowledgeHubResources.tsx';
import ServiceDeskKnowledgeArticleEmbedEditor, {
	LazyServiceDeskKnowledgeArticleEmbedEditor,
} from './ui/kb-article-embed-editor/index.tsx';

export const knowledgeHubArticleEmbedEditorRouteEntry = createEntry(
	knowledgeHubArticleEmbedEditorRoute,
	() => ({
		group: 'servicedesk',
		component: ServiceDeskKnowledgeArticleEmbedEditor,
		layout: serviceProjectLayout,
		resources: [...getServiceDeskNavigationResources(), ...getKnowledgeHubResources()],
		forPaint: [LazyAtlassianNavigation, LazyServiceDeskKnowledgeArticleEmbedEditor],
		perfMetricKey: 'service-management.knowledge.ep-editor',

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubArticleEmbedEditorRouteEntry.tsx',
				whichExportToUse: 'knowledgeHubArticleEmbedEditorRouteEntry',
			},

			enabled: true,
		},
	}),
);
